// @ts-nocheck
import type * as Types from '~~/shared/@types/generated/subscription/graphql-schema-types';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import type * as VueCompositionApi from '@vue/composition-api';
type ReactiveFunction<TParam> = () => TParam;

export const SubscriptionAnnouncementChangedDocument = gql`
    subscription AnnouncementChanged($licensedTerritory: String!) {
  announcementChanged(licensedTerritory: $licensedTerritory) {
    ... on AnnouncementChanged {
      id
      title
      description
      changeDate
      active
    }
  }
}
    `;

/**
 * __useAnnouncementChangedSubscription__
 *
 * To run a query within a Vue component, call `useAnnouncementChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAnnouncementChangedSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useAnnouncementChangedSubscription({
 *   licensedTerritory: // value for 'licensedTerritory'
 * });
 */
export function useAnnouncementChangedSubscription(variables: Types.AnnouncementChangedSubscriptionVariables | VueCompositionApi.Ref<Types.AnnouncementChangedSubscriptionVariables> | ReactiveFunction<Types.AnnouncementChangedSubscriptionVariables>, options: VueApolloComposable.UseSubscriptionOptions<Types.AnnouncementChangedSubscription, Types.AnnouncementChangedSubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<Types.AnnouncementChangedSubscription, Types.AnnouncementChangedSubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<Types.AnnouncementChangedSubscription, Types.AnnouncementChangedSubscriptionVariables>> = {}) {
  return VueApolloComposable.useSubscription<Types.AnnouncementChangedSubscription, Types.AnnouncementChangedSubscriptionVariables>(SubscriptionAnnouncementChangedDocument, variables, options);
}
export type AnnouncementChangedSubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<Types.AnnouncementChangedSubscription, Types.AnnouncementChangedSubscriptionVariables>;
export const SubscriptionCheckoutBalanceChangesDocument = gql`
    subscription CheckoutBalanceChanges($accessToken: String!) {
  checkoutBalanceChanges(authToken: $accessToken) {
    ... on CheckoutBalanceChangedPayload {
      currency
      nonPayableBalance
      payableBalance
      reference
      type
    }
  }
}
    `;

/**
 * __useCheckoutBalanceChangesSubscription__
 *
 * To run a query within a Vue component, call `useCheckoutBalanceChangesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutBalanceChangesSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useCheckoutBalanceChangesSubscription({
 *   accessToken: // value for 'accessToken'
 * });
 */
export function useCheckoutBalanceChangesSubscription(variables: Types.CheckoutBalanceChangesSubscriptionVariables | VueCompositionApi.Ref<Types.CheckoutBalanceChangesSubscriptionVariables> | ReactiveFunction<Types.CheckoutBalanceChangesSubscriptionVariables>, options: VueApolloComposable.UseSubscriptionOptions<Types.CheckoutBalanceChangesSubscription, Types.CheckoutBalanceChangesSubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<Types.CheckoutBalanceChangesSubscription, Types.CheckoutBalanceChangesSubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<Types.CheckoutBalanceChangesSubscription, Types.CheckoutBalanceChangesSubscriptionVariables>> = {}) {
  return VueApolloComposable.useSubscription<Types.CheckoutBalanceChangesSubscription, Types.CheckoutBalanceChangesSubscriptionVariables>(SubscriptionCheckoutBalanceChangesDocument, variables, options);
}
export type CheckoutBalanceChangesSubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<Types.CheckoutBalanceChangesSubscription, Types.CheckoutBalanceChangesSubscriptionVariables>;
export const SubscriptionCheckoutBonusChangedDocument = gql`
    subscription CheckoutBonusChanged($accessToken: String!) {
  checkoutBonusChanges(authToken: $accessToken) {
    ... on CheckoutBonusChangedPayload {
      code
      playerId
      productId
    }
  }
}
    `;

/**
 * __useCheckoutBonusChangedSubscription__
 *
 * To run a query within a Vue component, call `useCheckoutBonusChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutBonusChangedSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useCheckoutBonusChangedSubscription({
 *   accessToken: // value for 'accessToken'
 * });
 */
export function useCheckoutBonusChangedSubscription(variables: Types.CheckoutBonusChangedSubscriptionVariables | VueCompositionApi.Ref<Types.CheckoutBonusChangedSubscriptionVariables> | ReactiveFunction<Types.CheckoutBonusChangedSubscriptionVariables>, options: VueApolloComposable.UseSubscriptionOptions<Types.CheckoutBonusChangedSubscription, Types.CheckoutBonusChangedSubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<Types.CheckoutBonusChangedSubscription, Types.CheckoutBonusChangedSubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<Types.CheckoutBonusChangedSubscription, Types.CheckoutBonusChangedSubscriptionVariables>> = {}) {
  return VueApolloComposable.useSubscription<Types.CheckoutBonusChangedSubscription, Types.CheckoutBonusChangedSubscriptionVariables>(SubscriptionCheckoutBonusChangedDocument, variables, options);
}
export type CheckoutBonusChangedSubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<Types.CheckoutBonusChangedSubscription, Types.CheckoutBonusChangedSubscriptionVariables>;
export const SubscriptionDrawChangesDocument = gql`
    subscription DrawChanges($licensedTerritory: String!) {
  drawChanges(licensedTerritory: $licensedTerritory) {
    ... on DrawChangePayload {
      cause
      lotteryId
    }
  }
}
    `;

/**
 * __useDrawChangesSubscription__
 *
 * To run a query within a Vue component, call `useDrawChangesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDrawChangesSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useDrawChangesSubscription({
 *   licensedTerritory: // value for 'licensedTerritory'
 * });
 */
export function useDrawChangesSubscription(variables: Types.DrawChangesSubscriptionVariables | VueCompositionApi.Ref<Types.DrawChangesSubscriptionVariables> | ReactiveFunction<Types.DrawChangesSubscriptionVariables>, options: VueApolloComposable.UseSubscriptionOptions<Types.DrawChangesSubscription, Types.DrawChangesSubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<Types.DrawChangesSubscription, Types.DrawChangesSubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<Types.DrawChangesSubscription, Types.DrawChangesSubscriptionVariables>> = {}) {
  return VueApolloComposable.useSubscription<Types.DrawChangesSubscription, Types.DrawChangesSubscriptionVariables>(SubscriptionDrawChangesDocument, variables, options);
}
export type DrawChangesSubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<Types.DrawChangesSubscription, Types.DrawChangesSubscriptionVariables>;
export const SubscriptionOrderStateChangesDocument = gql`
    subscription OrderStateChanges($accessToken: String!) {
  orderStateChanges(authToken: $accessToken) {
    ... on OrderStateChangedPayload {
      reference
      state
    }
  }
}
    `;

/**
 * __useOrderStateChangesSubscription__
 *
 * To run a query within a Vue component, call `useOrderStateChangesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOrderStateChangesSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useOrderStateChangesSubscription({
 *   accessToken: // value for 'accessToken'
 * });
 */
export function useOrderStateChangesSubscription(variables: Types.OrderStateChangesSubscriptionVariables | VueCompositionApi.Ref<Types.OrderStateChangesSubscriptionVariables> | ReactiveFunction<Types.OrderStateChangesSubscriptionVariables>, options: VueApolloComposable.UseSubscriptionOptions<Types.OrderStateChangesSubscription, Types.OrderStateChangesSubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<Types.OrderStateChangesSubscription, Types.OrderStateChangesSubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<Types.OrderStateChangesSubscription, Types.OrderStateChangesSubscriptionVariables>> = {}) {
  return VueApolloComposable.useSubscription<Types.OrderStateChangesSubscription, Types.OrderStateChangesSubscriptionVariables>(SubscriptionOrderStateChangesDocument, variables, options);
}
export type OrderStateChangesSubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<Types.OrderStateChangesSubscription, Types.OrderStateChangesSubscriptionVariables>;
export const SubscriptionPlaySlipChangesDocument = gql`
    subscription PlaySlipChanges($accessToken: String!) {
  playSlipChanges(authToken: $accessToken) {
    ... on PlaySlipChangePayload {
      subscription
    }
  }
}
    `;

/**
 * __usePlaySlipChangesSubscription__
 *
 * To run a query within a Vue component, call `usePlaySlipChangesSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePlaySlipChangesSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = usePlaySlipChangesSubscription({
 *   accessToken: // value for 'accessToken'
 * });
 */
export function usePlaySlipChangesSubscription(variables: Types.PlaySlipChangesSubscriptionVariables | VueCompositionApi.Ref<Types.PlaySlipChangesSubscriptionVariables> | ReactiveFunction<Types.PlaySlipChangesSubscriptionVariables>, options: VueApolloComposable.UseSubscriptionOptions<Types.PlaySlipChangesSubscription, Types.PlaySlipChangesSubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<Types.PlaySlipChangesSubscription, Types.PlaySlipChangesSubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<Types.PlaySlipChangesSubscription, Types.PlaySlipChangesSubscriptionVariables>> = {}) {
  return VueApolloComposable.useSubscription<Types.PlaySlipChangesSubscription, Types.PlaySlipChangesSubscriptionVariables>(SubscriptionPlaySlipChangesDocument, variables, options);
}
export type PlaySlipChangesSubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<Types.PlaySlipChangesSubscription, Types.PlaySlipChangesSubscriptionVariables>;
export const SubscriptionPlayerSignupFinishedDocument = gql`
    subscription PlayerSignupFinished($accessToken: String!) {
  playerSignupFinished(authToken: $accessToken) {
    ... on PlayerSignupFinishedPayload {
      playerId
    }
  }
}
    `;

/**
 * __usePlayerSignupFinishedSubscription__
 *
 * To run a query within a Vue component, call `usePlayerSignupFinishedSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePlayerSignupFinishedSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = usePlayerSignupFinishedSubscription({
 *   accessToken: // value for 'accessToken'
 * });
 */
export function usePlayerSignupFinishedSubscription(variables: Types.PlayerSignupFinishedSubscriptionVariables | VueCompositionApi.Ref<Types.PlayerSignupFinishedSubscriptionVariables> | ReactiveFunction<Types.PlayerSignupFinishedSubscriptionVariables>, options: VueApolloComposable.UseSubscriptionOptions<Types.PlayerSignupFinishedSubscription, Types.PlayerSignupFinishedSubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<Types.PlayerSignupFinishedSubscription, Types.PlayerSignupFinishedSubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<Types.PlayerSignupFinishedSubscription, Types.PlayerSignupFinishedSubscriptionVariables>> = {}) {
  return VueApolloComposable.useSubscription<Types.PlayerSignupFinishedSubscription, Types.PlayerSignupFinishedSubscriptionVariables>(SubscriptionPlayerSignupFinishedDocument, variables, options);
}
export type PlayerSignupFinishedSubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<Types.PlayerSignupFinishedSubscription, Types.PlayerSignupFinishedSubscriptionVariables>;
export const SubscriptionScratchcardOrdersReadyDocument = gql`
    subscription ScratchcardOrdersReady($accessToken: String!) {
  scratchcardOrdersReady(authToken: $accessToken) {
    ... on ScratchcardOrderReadyPayload {
      orderId
    }
  }
}
    `;

/**
 * __useScratchcardOrdersReadySubscription__
 *
 * To run a query within a Vue component, call `useScratchcardOrdersReadySubscription` and pass it any options that fit your needs.
 * When your component renders, `useScratchcardOrdersReadySubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useScratchcardOrdersReadySubscription({
 *   accessToken: // value for 'accessToken'
 * });
 */
export function useScratchcardOrdersReadySubscription(variables: Types.ScratchcardOrdersReadySubscriptionVariables | VueCompositionApi.Ref<Types.ScratchcardOrdersReadySubscriptionVariables> | ReactiveFunction<Types.ScratchcardOrdersReadySubscriptionVariables>, options: VueApolloComposable.UseSubscriptionOptions<Types.ScratchcardOrdersReadySubscription, Types.ScratchcardOrdersReadySubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<Types.ScratchcardOrdersReadySubscription, Types.ScratchcardOrdersReadySubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<Types.ScratchcardOrdersReadySubscription, Types.ScratchcardOrdersReadySubscriptionVariables>> = {}) {
  return VueApolloComposable.useSubscription<Types.ScratchcardOrdersReadySubscription, Types.ScratchcardOrdersReadySubscriptionVariables>(SubscriptionScratchcardOrdersReadyDocument, variables, options);
}
export type ScratchcardOrdersReadySubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<Types.ScratchcardOrdersReadySubscription, Types.ScratchcardOrdersReadySubscriptionVariables>;
export const SubscriptionHighFrequencyOrderStateChangesDocument = gql`
    subscription HighFrequencyOrderStateChanges($accessToken: String!) {
  highFrequencyOrderChanges(authToken: $accessToken) {
    orderId
    status
  }
}
    `;

/**
 * __useHighFrequencyOrderStateChangesSubscription__
 *
 * To run a query within a Vue component, call `useHighFrequencyOrderStateChangesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useHighFrequencyOrderStateChangesSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useHighFrequencyOrderStateChangesSubscription({
 *   accessToken: // value for 'accessToken'
 * });
 */
export function useHighFrequencyOrderStateChangesSubscription(variables: Types.HighFrequencyOrderStateChangesSubscriptionVariables | VueCompositionApi.Ref<Types.HighFrequencyOrderStateChangesSubscriptionVariables> | ReactiveFunction<Types.HighFrequencyOrderStateChangesSubscriptionVariables>, options: VueApolloComposable.UseSubscriptionOptions<Types.HighFrequencyOrderStateChangesSubscription, Types.HighFrequencyOrderStateChangesSubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<Types.HighFrequencyOrderStateChangesSubscription, Types.HighFrequencyOrderStateChangesSubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<Types.HighFrequencyOrderStateChangesSubscription, Types.HighFrequencyOrderStateChangesSubscriptionVariables>> = {}) {
  return VueApolloComposable.useSubscription<Types.HighFrequencyOrderStateChangesSubscription, Types.HighFrequencyOrderStateChangesSubscriptionVariables>(SubscriptionHighFrequencyOrderStateChangesDocument, variables, options);
}
export type HighFrequencyOrderStateChangesSubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<Types.HighFrequencyOrderStateChangesSubscription, Types.HighFrequencyOrderStateChangesSubscriptionVariables>;